import { render } from "./HeadBarButton.vue?vue&type=template&id=85cbb6ce"
import script from "./HeadBarButton.vue?vue&type=script&lang=js"
export * from "./HeadBarButton.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__